export default "__VITE_PUBLIC_ASSET__3755a925__"